import React, {Fragment, useCallback, useState} from 'react';
import {Box, TextField, InputAdornment} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import {ItemTypes} from '../util/itemTypes';

const labelsByItemType = {
  [ItemTypes.TEMPERATURE]: 'Temp.',
  [ItemTypes.DANGER]: 'Warnung',
  [ItemTypes.FOG]: 'Nebel'
};
export const ArdItemInput = ({
  item,
  data: {key, value},
  callback,
  locationLocked,
  currentMap
}) => {
  const [itemValue, setItemValue] = useState(value.toString());

  const publicChange = useCallback(() => {
    const newValue = parseFloat(itemValue);
    if (isNaN(newValue)) setItemValue(value.toString());
    else {
      callback(item, {[key]: {value: parseFloat(itemValue)}});
      setItemValue(parseFloat(itemValue).toString().replace(',', '.'));
    }
  }, [itemValue, callback, value, key, item]);

  const privateChange = useCallback(
    e => {
      setItemValue(e.target.value);
    },
    [setItemValue]
  );

  const handleKeyUp = useCallback(
    e => {
      if (e.key === 'Enter') {
        publicChange();
      }
    },
    [publicChange]
  );

  const handleFocus = useCallback(e => {
    e.target.select();
  }, []);

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        width: '100%'
      }}>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'flex-end'
        }}>
        {locationLocked ? (
          <Box
            sx={{
              width: '100%',
              height: '50%',
              px: 0.5,
              pt: 0.5,
              display: 'flex',
              alignItems: 'flex-end'
            }}>
            <TextField
              label={labelsByItemType[item.type]}
              color={'secondary'}
              size={'small'}
              variant={'outlined'}
              name={`${currentMap}__${item.id}__input`}
              inputProps={{
                style: {
                  pointerEvents: 'auto',
                  paddingTop: 2,
                  paddingBottom: 2,
                  paddingLeft: 4,
                  textAlign: 'center'
                }
              }}
              sx={theme => ({
                '& .Mui-focused': {
                  '& > input, & > .MuiInputAdornment-root > svg': {
                    color: theme.palette.secondary.main
                  }
                }
              })}
              InputProps={{
                sx: {
                  p: 0,
                  pr: 0.5
                },
                endAdornment: (
                  <InputAdornment position='end' sx={{p: 0}}>
                    <EditIcon
                      size={'small'}
                      sx={theme => ({
                        fontSize: theme.typography.fontSize,
                        color: theme.palette.secondary.contrastText
                      })}
                    />
                  </InputAdornment>
                )
              }}
              value={itemValue}
              onFocus={handleFocus}
              onChange={privateChange}
              onBlur={publicChange}
              onKeyUp={handleKeyUp}
              fullWidth
            />
          </Box>
        ) : (
          <Fragment />
        )}
      </Box>
    </Box>
  );
};
